import type { TileResponse } from "./types";

/**
 * Tiny fetch wrapper. Throws on non-2xx so the caller can show a stale state.
 */
export async function fetchTile(endpoint: string): Promise<TileResponse> {
  const res = await fetch(endpoint, {
    headers: { Accept: "application/json" },
    cache: "no-store",
  });
  if (!res.ok) {
    throw new Error(`${endpoint} -> HTTP ${res.status}`);
  }
  return (await res.json()) as TileResponse;
}
